import { Box } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { VerticalAlignBottomOutlined } from '@material-ui/icons';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { downloadTransaction } from '../../../actions/report-actions';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles(theme => ({
  downloadIcon: {
    cursor: 'pointer',
    color: 'green',
    '& > svg': {
      height: 22,
    },
  },
}));

export const TransactionsFileCell = ({ params, setDownloadProgress }) => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const classes = useStyles();
  
  const handleDownloadClick = useCallback(() => {
    dispatch(downloadTransaction(setDownloadProgress, params.row.Id, params.row.IsInvoice));
  }, [dispatch, setDownloadProgress, params.row.Id, params.row.IsInvoice]);
  
  return (
    <Box>
      <span>{formatMessage({ id: 'download.transaction.file', defaultMessage: 'Download' })}</span>
      <IconButton
        className={classes.downloadIcon}
        onClick={handleDownloadClick}
        aria-label={formatMessage({ id: 'download.transaction.file', defaultMessage: 'Download' })}
      >
        <VerticalAlignBottomOutlined />
      </IconButton>
    </Box>
  );
};